import log from 'salvo-lite/log'

class LoadMore {
    constructor (theme, elem) {
        log.debug('LoadMore', 'Constructing', this)
        this._elem = elem
        this.pageToLoad = elem.dataset.loadMorePage
        this.pageMax = elem.dataset.loadMoreMax
        this.url = window.location.protocol + '//' + window.location.host + window.location.pathname
        this.qs = window.location.search.length === 0 ? '?page=' : window.location.search + '&page='
        this.stop = false
        this.response = null
        this.events = this.setEvents()
    }

    onInit () {
        log.debug('LoadMore', 'Initiating')
        this._elem.addEventListener('click', e => this.loadMore(e))
        log.debug('LoadMore', 'Initiated')
    }

    loadMore (e) {
        e.preventDefault()
        if (this.stop) return false
        log.debug('LoadMore', 'Load More Trigger Clicked!')
        this.fullUrl = this.url + this.qs + this.pageToLoad
        this._elem.dispatchEvent(this.events.start)
        this.fetchData(this.fullUrl).then(request => {
            log.debug('LoadMore', 'Response Received', request)
            this.response = request.response
            this.stop = this.pageToLoad === this.pageMax
            this._elem.dispatchEvent(this.events.complete)
            if (this.stop) return false
            this.pageToLoad = parseInt(this.pageToLoad) + 1
            this._elem.dataset.loadMorePage = this.pageToLoad
            this.pageToLoad = this._elem.dataset.loadMorePage
        })
    }

    fetchData (url) {
        return new Promise((resolve, reject) => {
            log.debug('LoadMore', 'Fetching Data', this)
            let request = new XMLHttpRequest()
            request.open('GET', url)
            request.responseType = 'document'
            request.onload = () => {
                if (request.status === 200) {
                    log.debug('LoadMore', 'Retrieved Data', request)
                    resolve(request)
                } else {
                    reject(Error(`Data couldnt be retrived, error code: ${request.statusText}`))
                }
            }
            request.onerror = () => {
                reject(Error['There was a network error.'])
            }
            request.send()
        })
    }

    setEvents () {
        return {
            'start': new CustomEvent('load-more-start', { detail: this }),
            'complete': new CustomEvent('load-more-complete', { detail: this })
        }
    }
}

export default LoadMore



// WEBPACK FOOTER //
// ./src/scripts/components/LoadMore.js